import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, formatDate, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { BANK_CASH, RECEIPT_MODE } from '../../../../../constants/dropdown';
import { AddDetailsReceiptForm } from './AddDetailsReceiptForm';




const TABLE_HEADER = [
    {
        header: 'CNT No',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row.cnt}`}
                </span>
            );
        },
    },
    {
        header: 'CNT Type',
        accessor: 'type'
    },
    {
        header: 'CNT Date',
        accessor: (row) => `${getCurrentDateTime('date', row.cnt_date)}`
    },
    {
        header: 'Product Type',
        accessor: 'type'
    },
    {
        header: 'Location',
        accessor: (row) => row?.location?.warehouse_name
    },
    {
        header: 'Supplier Name',
        accessor: (row) => row?.supplier?.ledger_name
    },
    {
        header: 'Invoice No',
        accessor: 'invoice_no'
    },
    {
        header: 'Net Amount',
        accessor: 'net_amt'
    },
    {
        header: 'Created At',
        accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];

const initialConsignmentDataObj = {
    data: [],
    loading: false
};

const initialIndoorRegistrationDataObj = {
    data: [],
    loading: false
};


export const TPAReceiptVoucher = () => {
    const doctorIDRef = useRef();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [consignmentDataObj, setConsignmentDataObj] = useState(initialConsignmentDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialIndoorRegistrationDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false)
    const [accountLedger, setAccountLedger] = useState([])
    const [sponsorDropdown, setSponsorDropdown] = useState([]);
    const [id, setId] = useState('')


    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                invoice_no: Yup.string().required(' '),
                invoice_from: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
            bill: {
                out_sourced: 'No',
                tds_amt: 0,
                disc_amt: 0,
                gst_amt: 0,
                net_amt: 0
            }
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;
    const column = watch('view_column')
    const VOUCHER_DETAILS_HEADER = [
        {
            header: 'Bill No', accessor: (row) => row?.
                finalbilldetails?.
                bill_no
        },
        {
            header: 'Bill Date',
            accessor: (row) => {
                if (row?.finalbilldetails?.date && row?.finalbilldetails?.time) {
                    return `${formatDate(row.finalbilldetails.date)} ${row.finalbilldetails.time}`;
                } else {
                    return "-";
                }
            }
        },
        {
            header: 'IPD No', accessor: 'ipd_no'
        },
        {
            header: 'Patient Name', accessor: (row) => `${row?.patient?.name_suffix}${row?.patient?.first_name}${row?.patient?.last_name}`
        },
        { header: 'Net Amt', accessor: (row) => row.finalbilldetails?.net_amt || 0 },
        {
            header: 'Current O/S', accessor: (row) => row.finalbilldetails?.
                balance_amt
        },
        { header: 'Adj Amt', accessor: 'adj_amt' },
        { header: 'Tds', accessor: 'tds' },
        { header: 'Tcs', accessor: 'tcs' },
        { header: 'Rebate & Dis', accessor: 'rebate_dis' },
        { header: 'Total Adj', accessor: 'total_adj' },
        {
            header: 'Balance', accessor: (row) => row.finalbilldetails?.
                balance_amt
        },
    ]

    useEffect(() => {
        let total_qty = 0;
        let total_amt = 0;
        let disc_amt = 0;
        let net_amt = 0;
        let gst_amt = 0;

        detailList.forEach((detail) => {
            total_qty += detail.rec_qty;
            total_amt += detail.amount;
            disc_amt += detail.disc_amt;
            gst_amt += detail.gst_amt;
            net_amt += detail.net_amt;
        });

        // Round net_amt to the nearest integer
        const roundedNetAmt = Math.round(net_amt);

        // Calculate the round off difference (original net_amt - rounded net_amt)
        const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));

        // Set the calculated values
        setValue('total_qty', total_qty);
        setValue('total_amt', total_amt);
        setValue('disc_amt', disc_amt);
        setValue('gst_amt', gst_amt);
        setValue('net_amt', roundedNetAmt); // Set the rounded value as net_amt
        setValue('round_off', Math.abs(roundOff));  // Set the absolute value of the round off difference
    }, [detailList, setValue]);

    const netAmtWatch = watch('bill.net_amt');
    const recAmt1Watch = watch('bill.rec_amt_1');
    const recAmt2Watch = watch('bill.rec_amt_2');
    const payMode = watch('bill.pay_mode');

    useEffect(() => {
        const total_recpt = +recAmt1Watch + +recAmt2Watch;
        let balanceAmt = netAmtWatch - total_recpt;
        if (payMode === "CASH") {
            setValue('bill.rec_amt_1', netAmtWatch);
            setValue('bill.rec_amt_2', 0);
            setValue('bill.balance_amt', 0);
            setValue('bill.total_recpt', netAmtWatch);
        } else if (["Bank", "UPI", "Paytm", "RTGS/NEFT/Cheque", "Credit Card", "Debit Card"].includes(payMode)) {
            setValue('bill.rec_amt_1', 0);
            setValue('bill.rec_amt_2', netAmtWatch);
            setValue('bill.balance_amt', 0);
            setValue('bill.total_recpt', netAmtWatch);
        } else {
            setValue('bill.total_recpt', total_recpt);
            setValue('bill.balance_amt', balanceAmt);
        }
    }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

    useEffect(() => {
        if (selectedRecord) {
            const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
                '__v',
                '_id',
                'createdAt',
                'status',
                'add_details',
                'uhid'
            ]);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
            setDetailList(selectedRecord.add_details);
            setValue('invoice_no', selectedRecord?.invoice_no)
            setValue('cnt', selectedRecord?.cnt)
            const formattedCrnDate = selectedRecord?.cnt_date
                ? new Date(selectedRecord.cnt_date).toISOString().split('T')[0]
                : '';
            setValue('cnt_date', formattedCrnDate);
            const formattedInvoiceDate = selectedRecord?.invoice_date
                ? new Date(selectedRecord.invoice_date).toISOString().split('T')[0]
                : '';
            setValue('invoice_date', formattedInvoiceDate);
            setValue('type', selectedRecord?.type)
            setValue('supplier', selectedRecord?.supplier)
            setValue('location', selectedRecord?.location?._id)
            setValue('product_type', selectedRecord?.product_type)
            setValue('invoice_from', selectedRecord?.invoice_from)
            setValue('amd_no', selectedRecord?.amd_no)
            setValue('remarks', selectedRecord?.remarks)
            setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
            setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
        } else {
            reset();
        }
    }, [selectedRecord]);


    const getAccountLedgerData = useCallback(async () => {
        const data = await dropdownFetch('account-ledger');
        setAccountLedger(data);
    }, []);

    useEffect(() => {
        getAccountLedgerData()
    }, { getAccountLedgerData })


    const getSponsorDropdown = useCallback(async () => {
        const data = await dropdownFetch('sponsor');
        if (!selectedRecord) {
            const [defaultSponsor] = data.filter(({ status }) => status === 'default');
            setValue('sponsor', defaultSponsor?._id);
        }
        setSponsorDropdown(data);
    }, []);

    useEffect(() => {
        getSponsorDropdown()
    }, [getSponsorDropdown])

    const formSubmit = async (formValues) => {
        if (detailList.length === 0) {
            toast('Please add the Details first', { variant: 'warning' });
            return;
        }
        setLoading(true);
        const payload = { ...formValues, add_details: detailList };
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/consignment-receipt-update' : '/consignment-receipt-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: payload
        });
        console.log(response, "HELLO RESPONSE")
        if (response?.success && response.data) {
            toast(`Successfully ${editFlag ? 'edited' : 'created'} Consignment Receipt`, { variant: 'success' });
            setSelectedRecord(response?.data);
            setCurrentAction();
        } else {
            toast(`Failed to ${editFlag ? 'edit' : 'create'} Consignment Receipt`, { variant: 'error' });
        }
        setLoading(false);
    };



    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/consignment-receipt-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully Cancel Consignment Receipt', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to Cancel Consignment Receipt', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/consignment-receipt-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Consignment Receipt', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete Consignment Receipt', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setConsignmentDataObj({ loading: true });
        const response = await request('', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const filteredData = sortedData.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setConsignmentDataObj({ loading: false, data: filteredData });
            setOriginalData(filteredData)
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setConsignmentDataObj({ loading: false });
        }
    };

    useEffect(() => {
        if (consignmentDataObj.data && consignmentDataObj.data.length > 0) {
            setOriginalData(consignmentDataObj.data);
            setIsFiltered(false);
        }
    }, [consignmentDataObj.data]);

    const handleUhidSearch = () => {
        const lowercasedInput = input.toLowerCase();
        const filtered = consignmentDataObj.data.filter((item) =>
            item.invoice_no?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleUhidSearch();
    };


    const tpa = watch('tpa');

    useEffect(() => {
        fetchIndoorRegistrationData();
    }, [tpa]);

    const fetchIndoorRegistrationData = async () => {
        setIndoorRegisterationDataObj({ loading: true });
        const response = await request('/indoor-registeration-bill-detail-list', { method: 'GET' });
        if (response.success) {
            const admitDataFilter = response.data.filter(item =>
                item.admission_status === 'discharged'
            );
            const sponsorFilter = admitDataFilter.filter(item =>
                item.patient.sponsor._id === tpa
            );
            setIndoorRegisterationDataObj({ loading: false, data: sponsorFilter });
            setOriginalData(sponsorFilter);
            console.log("Filtered Indoor Registration Data based on tpa:", sponsorFilter);
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false });
        }
    };


    const handleEditRows = (row) => {
        setAddDetailsDialogOpen(true)
        setId(row._id)
    }


    const onDetailAddHandler = (formValues, id) => {
        console.log("HELLLLO FORMVALUES AND THE ID", formValues, id)
        const newMedicineData = {
            _id: formValues.id,
            adj_amt: formValues.adj_amt,
            tds: formValues.tds,
            tcs: formValues.tcs,
            rebate_dis: formValues.rebate_dis,
            total_adj: formValues.total_adj,
        };
        setIndoorRegisterationDataObj((prevState) => {
            const existingData = prevState.data || [];

            // Check if an item with the same _id already exists
            const existingItemIndex = existingData.findIndex((item) => item._id === newMedicineData._id);

            if (existingItemIndex !== -1) {
                // If an item with the same _id exists, update that row
                const updatedData = [...existingData];
                updatedData[existingItemIndex] = {
                    ...updatedData[existingItemIndex],
                    ...newMedicineData, // Update the row with new values
                };

                return {
                    ...prevState,
                    data: updatedData,
                };
            }
            console.log("No matching ID found, no changes made.");
            return prevState;
        });
        console.log("Updated Indoor Registration Data:", indoorRegisterationDataObj);
    };


    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                TPA Receipt Voucher
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord()
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/ print${pathname} ? refId = ${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: "1.4rem" }}>TPA</Typography>
                                    <SelectTag disabled={!['new', 'edit'].includes(currentAction)} formControlSX={{ flex: 0.8 }}
                                        name="tpa"
                                        menus={sponsorDropdown}

                                    />
                                </Stack>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: "1.4rem" }}>RecNo./Date</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.4 }} name="rec_no" placeholder="RecNo" />
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.4 }} name="date" type="date" />
                                </Stack>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.27, fontWeight: 700, fontSize: "1.4rem" }}>Rec Category</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="rec_category" placeholder="Rec Category" />
                                </Stack>
                            </Stack>
                            <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: "1.4rem" }}>Pay Mode</Typography>
                                    <SelectTag
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                        formControlSX={{ flex: 0.8 }} name="pay_mode"
                                        menus={RECEIPT_MODE}
                                        placeholder="Pay Mode" />
                                </Stack>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: "1.4rem" }}>Bank/Cash</Typography>
                                    <SelectTag disabled={!['new', 'edit'].includes(currentAction)} formControlSX={{ flex: 0.8 }} name="bank_cash" placeholder="Select Bank/Cash"
                                        menus={BANK_CASH}
                                    />
                                </Stack>
                                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: "1.4rem" }}>Rec. Amt</Typography>
                                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.6 }} name="rec_amt" />
                                    <Button
                                        variant="contained"
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                    >
                                        Auto Adjust
                                    </Button>
                                    <Button
                                        variant="contained"
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                    >
                                        Refresh
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginTop: "1%", boxShadow: '0px 2px 2px #0099ff' }}>
                            <Table
                                containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                data={indoorRegisterationDataObj.data || []}
                                columns={VOUCHER_DETAILS_HEADER}
                                size="small"
                                editMedicine={true}
                                onClickEdit={handleEditRows}
                            />
                        </Grid>
                        <Stack direction="row" spacing={2} marginTop={"1%"}>
                            <Stack sx={{ flex: 6 }} spacing={0.1} direction="column" alignItems="center">
                                <Typography sx={{ fontWeight: 700, fontSize: "1.4rem" }}>Narration </Typography>
                                <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8, width: '100%', height: '80px' }} name="narration" />
                            </Stack>
                            <Stack sx={{ flex: 2 }} spacing={0.1} direction="column" alignItems="center">
                                <Typography sx={{ fontWeight: 700, fontSize: "1.4rem" }}>Adjusted Amt.</Typography>
                                <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.4 }} name="adjusted_amt" placeholder="Adjusted Amt" />
                            </Stack>
                            <Stack sx={{ flex: 2 }} spacing={0.1} direction="column" alignItems="center">
                                <Typography sx={{ fontWeight: 700, fontSize: "1.4rem" }}>Rebate & Discount</Typography>
                                <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="rebate_discount" placeholder="Rebate & Discount" />
                            </Stack>
                            <Stack sx={{ flex: 2 }} spacing={0.1} direction="column" alignItems="center">
                                <Typography sx={{ fontWeight: 700, fontSize: "1.4rem" }}>Net Amt</Typography>
                                <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="net_amount" placeholder="Net Amount" />
                            </Stack>
                        </Stack>
                    </FormProvider>
                </Container>
            </Paper >


            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Consignment Receipt Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '1.4rem' // Adjust input font size
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Consignment Receipt"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_HEADER}
                    data={originalData || []}
                    loading={consignmentDataObj.loading}
                    onRowClick={(row) => {
                        delete row.patient;
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
            <Dialog
                open={addDetailsDialogue}
                onClose={() => setAddDetailsDialogOpen(false)}
                PaperProps={{ sx: { width: '50%', height: '50vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddDetailsReceiptForm
                    onClose={() => setAddDetailsDialogOpen(false)}
                    onAdd={onDetailAddHandler}
                    id={id}
                />
            </Dialog>
        </>
    );
};
